
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M359.4 57.25c-7.875-4.094-17.52-1.031-21.58 6.781-4.078 7.844-1.047 17.5 6.797 21.59C408.4 118.9 448 184.2 448 256c0 105.9-86.13 192-192 192S64 361.87 64 256c0-71.84 39.63-137.1 103.4-170.4 7.844-4.094 10.88-13.75 6.797-21.59-4.097-7.79-13.797-10.85-21.597-6.76C78.22 96.03 32 172.2 32 256c0 123.5 100.5 224 224 224s224-100.5 224-224c0-83.8-46.2-159.97-120.6-198.75zM255.1 288c9.7 0 16.9-7.2 16.9-16V16c0-8.844-7.156-16-15.1-16S240 7.156 240 16v256c0 8.8 7.2 16 15.1 16z"}})])
          )
        }
      }
    